/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Channel } from "./Channel";
import { PageInfo } from "./PageInfo";
import * as t from "io-ts";

// required attributes
const ChannelsR = t.interface({
  channels: t.readonlyArray(Channel, "array of Channel"),

  page_info: PageInfo
});

// optional attributes
const ChannelsO = t.partial({});

export const Channels = t.intersection([ChannelsR, ChannelsO], "Channels");

export type Channels = t.TypeOf<typeof Channels>;
